class CartWatcher {
	constructor() {
		this.emitCartChanges();

		subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {this.emitCartChanges()});
	}

	async fetchCart() {
		const response = await fetch(`${routes.cart_url}`,{
				method: 'GET',
				headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
			}
		);
		return response.json();
	}

    storeCart(cart) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }

    storedCart() {
        return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
        const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
        let result = {
            added: onlyInLeft(newCart.items, oldCart.items),
            removed: onlyInLeft(oldCart.items, newCart.items),
        };

        oldCart.items.forEach(oi => {
            const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
            if (!ni) return;
            let quantity = ni.quantity - oi.quantity;
            let item = { ...ni };
            item.quantity = Math.abs(quantity);
            quantity > 0 ? result.added.push(item) : result.removed.push(item)
        });

        return result;
    }

    async emitCartChanges() {
        const newCart = await this.fetchCart();
        const oldCart = this.storedCart();
        const changes = this.findCartChanges(oldCart, newCart);
		let buttonMainDefaultText = window.bulkFeedStrings.collection_add_to_bag;
		let buttonMainCartText = window.bulkFeedStrings.collection_added_to_bag;
		let buttonDefaultText = window.bulkFeedStrings.product_add_to_bag,
			buttonCartText = window.bulkFeedStrings.product_added_to_bag,
			cartIDs = [],
			bulkIDs = [];

		// Get array of cart items IDs
		newCart.items.forEach( cart_item => {
			cartIDs.push(cart_item.id);
		});

		document.querySelectorAll('section .js-bulk-atc').forEach(button => {
			bulkIDs.push(+button.dataset.id);
		});

		// Get only the common items from compared arrays
		const intersection = bulkIDs.filter(item => cartIDs.includes(item));

		if (intersection.length) {
			intersection.forEach(id => {
				let bulkAtcText = document.querySelector(`.js-bulk-atc[data-id="${id}"] .js-bulk-atc-text`);
				if (bulkAtcText) {
					if (bulkAtcText.classList.contains('js-bulk-atc-main-text')) {
						bulkAtcText.innerText = buttonMainCartText;
					} else {
						bulkAtcText.innerText = buttonCartText;
						document.querySelector(`.js-bulk-atc[data-id="${id}"] .grid-item-collection__icon`).classList.add('grid-item-collection__icon--added');
					}
				}
			})
		}

		changes['removed'].forEach(item => {
            let variantID = item.id;

			let bulkAtcText = document.querySelector(`.js-bulk-atc[data-id="${variantID}"] .js-bulk-atc-text`);

            if (bulkAtcText) {
                if (bulkAtcText.classList.contains('js-bulk-atc-main-text')) {
                    bulkAtcText.innerText = buttonMainDefaultText;
                }else{
                    bulkAtcText.innerText = buttonDefaultText;
                    document.querySelector(`.js-bulk-atc[data-id="${variantID}"] .grid-item-collection__icon`).classList.remove('grid-item-collection__icon--added');
                }
            }
        });

        this.storeCart(newCart);
    }
}
window.addEventListener('load', function(event) {
    document.querySelectorAll('section .js-bulk-atc:not(.js-bulk-atc-main)').forEach(button => {
        button.addEventListener('click', function() {
            let cart = document.querySelector("cart-drawer");
			const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            formData.append("id", this.dataset.id);
            formData.append("quantity", 1);
            formData.append(
                'sections',
                cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then(response => response.json())
                .then(cart_item => {
                    cart.renderContents(cart_item);

                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'bulk-feed',
                        productVariantId: formData.get('id'),
                        cartData: cart_item,
                    });
                })
            .catch(error => {
                console.error('Error adding item to cart:', error);
            }).finally(() => {
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

            });;
        });   
	});

	// Add button text on click
	let mainButton = document.querySelectorAll('section .js-bulk-atc-main');
	if (mainButton) {
		mainButton.forEach(button => {
			button.addEventListener('click', function() {
				let cart = document.querySelector("cart-drawer");
				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData();
				formData.append("id", this.dataset.id);
				formData.append("quantity", 1);
				formData.append(
					"sections",
					cart.getSectionsToRender().map((section) => section.id)
				);
				formData.append('sections_url', window.location.pathname);

				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then(response => response.json())
					.then(cart_item => {
						cart.renderContents(cart_item);

						publish(PUB_SUB_EVENTS.cartUpdate, {
							source: 'bulk-feed',
							productVariantId: formData.get('id'),
							cartData: cart_item,
						});
					})
				.catch(error => {
					console.error('Error adding item to cart:', error);
				}).finally(() => {
					if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
				});
			});
		});
	}
}, {passive: true});